import { render } from "./SelecaoEntidades.vue?vue&type=template&id=0a4d4681"
import script from "./SelecaoEntidades.vue?vue&type=script&lang=js"
export * from "./SelecaoEntidades.vue?vue&type=script&lang=js"

import "./SelecaoEntidades.vue?vue&type=style&index=0&id=0a4d4681&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__